import { useCallback } from "react";
import usePreferences from "hooks/usePreferences";
import UnitHelper from "../../helpers/UnitHelper";
import MetricHelpers from "../../helpers/MetricHelpers";
import type { CircuitMetric, ExerciseMetric, RoundMetric, ScoreMetadata } from "types";

interface UnitParserReturn {
  results: {
    value: number;
    unit: string;
    formatted: string;
  }[];
  value: number;
  formatted: string;
}

interface UseUnitParser {
  revert: boolean;
}

function useUnitParser(props?: UseUnitParser) {
  const { revert = false } = props || {};

  const [preferences] = usePreferences();

  return useCallback(
    (value: number, metricMetadata?: ExerciseMetric | CircuitMetric | RoundMetric | ScoreMetadata | null) => {
      const displayMetadata = preferences.imperialSystemEnabled
        ? metricMetadata?.displayMetadata?.imperial
        : metricMetadata?.displayMetadata?.metric;

      if (revert) {
        const revertedResult = UnitHelper.processUnit(value, {
          from: displayMetadata?.unit,
          to: MetricHelpers.getSourceUnit(metricMetadata),
          /**
           * @description
           * Force 4 decimals when reverting so we don't lose precision
           */
          decimals: 100,
        }) as UnitParserReturn;

        return revertedResult;
      }

      const displayDecimals = displayMetadata?.decimals;

      return UnitHelper.processUnit(value, {
        from: MetricHelpers.getSourceUnit(metricMetadata),
        to: displayMetadata?.unit,
        decimals: displayDecimals,
      }) as UnitParserReturn;
    },
    [preferences.imperialSystemEnabled, revert]
  );
}
export default useUnitParser;
